'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Raven from 'raven-js';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import DeletedMessageBanner from './DeletedMessageBanner';
import { jsx as _jsx } from "react/jsx-runtime";
class ThreadWithDeletedMessagesBanner extends Component {
  constructor(props) {
    super(props);
    this.onClickViewMessages = this.onClickViewMessages.bind(this);
    this.onClickDeleteMessages = this.onClickDeleteMessages.bind(this);
  }
  componentDidMount() {
    Raven.capturePageEvent('viewThreadWithDeletedMessagesBanner');
  }
  onClickViewMessages() {
    const {
      threadId,
      onClickViewMessages
    } = this.props;
    onClickViewMessages({
      threadId,
      includeDeletedHistory: true
    });
  }
  onClickDeleteMessages() {
    const {
      threadId,
      onClickDeleteMessages
    } = this.props;
    onClickDeleteMessages({
      threadId
    });
  }
  renderViewMessagesLink() {
    return /*#__PURE__*/_jsx(UIButton, {
      className: "m-left-2",
      use: "link",
      onClick: this.onClickViewMessages,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.threadContainsDeletedMessages.viewMessagesLink"
      })
    });
  }
  renderHardDeleteLink() {
    return /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: this.onClickDeleteMessages,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.threadContainsDeletedMessages.deleteForeverLink"
      })
    });
  }
  render() {
    const {
      numSoftDeletedMessages,
      shouldShowDeletedMessagesBanner
    } = this.props;
    return shouldShowDeletedMessagesBanner ? /*#__PURE__*/_jsx("div", {
      className: "m-all-4",
      children: /*#__PURE__*/_jsx(DeletedMessageBanner, {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "conversations-thread-view.thread-deletion.threadContainsDeletedMessages.title",
            options: {
              count: numSoftDeletedMessages,
              viewLink: this.renderViewMessagesLink(),
              deleteForeverLink: this.renderHardDeleteLink()
            }
          })
        })
      })
    }) : null;
  }
}
ThreadWithDeletedMessagesBanner.displayName = 'ThreadWithDeletedMessagesBanner';
ThreadWithDeletedMessagesBanner.propTypes = {
  numSoftDeletedMessages: PropTypes.number.isRequired,
  onClickDeleteMessages: PropTypes.func.isRequired,
  onClickViewMessages: PropTypes.func.isRequired,
  shouldShowDeletedMessagesBanner: PropTypes.bool.isRequired,
  threadId: PropTypes.string.isRequired
};
export default ThreadWithDeletedMessagesBanner;